<template>
  <el-dialog
    title="视频播放"
    :visible.sync="visible"
    :close-on-click-modal="true"
    width="70%"
    center
    @close="closeVideo"
  >
    <div style="text-align: center;">
      <video
        ref="videoPlayer"
        :src="videoUrl"
        controls
        style="max-width: 100%; max-height: 500px;"
        @error="handleVideoError"
      >您的浏览器不支持视频播放</video>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'VideoPlayer',
  props: {
    // 控制弹窗显示隐藏
    value: {
      type: Boolean,
      default: false
    },
    // 视频地址
    videoUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    // 关闭视频播放
    closeVideo() {
      this.visible = false;
      // 停止视频播放
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
        this.$refs.videoPlayer.currentTime = 0;
      }
      // 通知父组件视频已关闭
      this.$emit('close');
    },
    
    // 视频加载错误处理
    handleVideoError() {
    //   this.$message.error('视频加载失败，请检查视频地址是否正确');
    }
  }
};
</script>

<style scoped>
/* 可以添加自定义样式 */
</style>